// routes
import { PATH_DASHBOARD } from "../../../routes/paths";
// components
import SvgColor from "../../../components/svg-color";

// ----------------------------------------------------------------------

const icon = (name) => (
    <SvgColor
        src={`/assets/icons/navbar/${name}.svg`}
        sx={{ width: 1, height: 1 }}
    />
);

const ICONS = {
    user: icon("ic_user"),
    ecommerce: icon("ic_ecommerce"),
    analytics: icon("ic_analytics"),
    dashboard: icon("ic_dashboard"),
};

const navConfig = [
    // GENERAL
    // ----------------------------------------------------------------------
    {
        subheader: "Admin Panel",
        items: [
            {
                title: "Users",
                path: PATH_DASHBOARD.user.root,
                icon: ICONS.user,
                roles: ["admin", "super-support", "support"],
            },
            {
                title: "Pilot",
                path: PATH_DASHBOARD.pilot,
                icon: ICONS.user,
                roles: ["admin"],
            },
            {
                title: "Clone",
                path: PATH_DASHBOARD.clone,
                icon: ICONS.user,
                roles: ["admin", "super-support"],
            },
            {
                title: "Backfill",
                path: PATH_DASHBOARD.backfill,
                icon: ICONS.user,
                roles: ["admin"],
            },
            {
                title: "Safe Backfill",
                path: PATH_DASHBOARD.safeBackfill,
                icon: ICONS.user,
                roles: ["admin", "super-support"],
            },
            {
                title: "Data Export",
                path: PATH_DASHBOARD.data.weight,
                icon: ICONS.user,
                roles: ["admin", "super-support", "support"],
                children: [
                    { title: "Weight", path: PATH_DASHBOARD.data.weight },
                    { title: "Meal", path: PATH_DASHBOARD.data.meal },
                    { title: "CheckIn", path: PATH_DASHBOARD.data.checkin },
                ],
            },
            {
                title: "Feedback",
                path: PATH_DASHBOARD.feedback,
                icon: ICONS.user,
                roles: ["admin"],
            },
            {
                title: "Links",
                path: PATH_DASHBOARD.links,
                icon: ICONS.dashboard,
                roles: ["admin"],
            },
            {
                title: "Control Flags",
                path: PATH_DASHBOARD.controlFlags,
                icon: ICONS.analytics,
                roles: ["admin"],
            },
            {
                title: "Bulk Email to UserId",
                path: PATH_DASHBOARD.bulkEmailToUserId,
                icon: ICONS.analytics,
                roles: ["admin"],
            },
            {
                title: "Add to Activation Debug",
                path: PATH_DASHBOARD.addToActivationDebug,
                icon: ICONS.analytics,
                roles: ["admin"],
            },
            {
                title: "Beta Group",
                path: PATH_DASHBOARD.betaGroup,
                icon: ICONS.analytics,
                roles: ["admin"],
            },
            {
                title: "Add to Pilot",
                path: PATH_DASHBOARD.addToPilot,
                icon: ICONS.user,
                roles: ["admin", "super-support"],
            },
            {
                title: "CheckIn",
                path: PATH_DASHBOARD.checkIn,
                icon: ICONS.analytics,
                roles: ["admin"],
            },
        ],
    },

    // MANAGEMENT
    // ----------------------------------------------------------------------
    // {
    //   subheader: "management",
    //   items: [
    //     {
    //       title: "user",
    //       path: PATH_DASHBOARD.user.root,
    //       icon: ICONS.user,
    //       children: [
    //         { title: "Four", path: PATH_DASHBOARD.user.four },
    //         { title: "Five", path: PATH_DASHBOARD.user.five },
    //         { title: "Six", path: PATH_DASHBOARD.user.six },
    //       ],
    //     },
    //   ],
    // },
];

export default navConfig;
